<div class="dialog container-fluid ps-0">
    <div class="dialog-title">
        <h6 class="pl-3">Schedule Inspection Session <img src="assets/svg/close-white.svg" alt="close"
                (click)="close()"></h6>
    </div>
    <div class="content pt-0 px-0 ">
        <div class="row px-4 mb-4 details mx-0 py-2">
            <div class="col-md-2">
                <label>Order</label>
                <div class="value">#{{vendorOrderId}}</div>
            </div>
            <div class="col-md-3">
                <label>Customer</label>
                <div class="value">{{customerName}}</div>
            </div>
            <div class="col-md-2">
                <label>Session</label>
                <div class="value">{{sessionCount}}</div>
            </div>
            <div class="col-md-3">
                <label>Date & Time</label>
                <div class="value">{{
                    inspectionForm.get('inspectionDate').value ?
                    ( inspectionForm.get('inspectionDate').value | date:'mediumDate') :
                    '--'
                    }},
                    {{(inspectionForm.get('inspectionTime').value | date:'shortTime') || '--' }}</div>
            </div>
            <div class="col-md-1">
                <label>Parts</label>
                <div class="value">{{batchParts?.length}}</div>
            </div>
            <div class="col-md-1">
                <label>Batches</label>
                <div class="value">{{batches?.length}}</div>
            </div>
        </div>
        <div class="px-4 mb-4 main-tab">
            <form [formGroup]="inspectionForm">
                <mat-tab-group>
                    <mat-tab label="Step 1. Batches & Parts">
                        <div class="pt-4">
                            <div class="d-flex">
                                <div class="pl-0 flex-grow-1 pr-2">
                                    <label>Inspection Date</label>
                                    <div class="date-picker mr-0 ml-0">
                                        <input type="text" formControlName="inspectionDate" [min]="today" matInput
                                            [matDatepicker]="inspectionDatePicker">
                                        <mat-datepicker-toggle class="icon" matSuffix
                                            [for]="inspectionDatePicker"></mat-datepicker-toggle>
                                        <mat-datepicker #inspectionDatePicker></mat-datepicker>
                                    </div>
                                </div>
                                <div class="pl-0 flex-grow-1 time-picker d-flex flex-column">
                                    <label>Time</label>
                                    <mat-form-field appearance="outline" floatLabel="true">
                                        <!-- Custom display span -->
                                        <span class="formatted-time-display" [owlDateTimeTrigger]="timePicker">
                                            {{ inspectionForm.get('inspectionTime').value | date: 'shortTime' }}
                                        </span>
                                        <input placeholder="HH:MM A" formControlName="inspectionTime" matInput
                                            [owlDateTime]="timePicker" [min]="minTime" readonly>
                                        <owl-date-time #timePicker pickerType="timer" [hour12Timer]="true"
                                            [startAt]="minTime"></owl-date-time>
                                        <span [owlDateTimeTrigger]="timePicker" class="trigger">
                                            <img alt="time chooser icon" src="assets/svg/clock.svg" matSuffix>
                                        </span>
                                    </mat-form-field>

                                </div>
                            </div>
                            <div *ngIf="batches?.length > 0">
                                <label class="pb-2">The below batches are inspection-ready</label>
                                <div class="pb-2" *ngFor="let item of batches">
                                    <mat-checkbox color="warn" (change)="onBatchSelectionChange($event, item)">
                                        <div class="d-flex">
                                            <div class="col-2 d-flex align-items-center border part-img">
                                                <img class="pointer" [src]="item?.vendorOrderItem?.thumbnail"
                                                    alt="Part image">
                                            </div>
                                            <div class="col-8">
                                                <p class="mb-2 light text-truncate">Deadline:
                                                    <span class="medium">
                                                        {{(item?.revisedDeadline !== '' ? item?.revisedDeadline :
                                                        item?.dispatchDate) | date:'medium'}}
                                                    </span>
                                                </p>
                                                <p class="mb-2 light text-truncate">
                                                    <span
                                                        class="medium text-break">{{item?.vendorOrderItem?.model_attributes?.file_name
                                                        ||
                                                        'NA'}}
                                                    </span>
                                                </p>
                                                <p class="mb-2 light text-truncate">Part ID:
                                                    <span
                                                        class="medium">{{item?.vendorOrderItem?.model_attributes?.model_code
                                                        || 'NA'}}
                                                    </span>
                                                </p>
                                            </div>
                                            <!-- :DONOT DELETE -->
                                            <!-- <div class="col-4">
                                                <p class="mb-2 light text-truncate">Rounds Done:
                                                    <span class="medium">01
                                                    </span>
                                                </p>
                                            </div> -->
                                            <div class="col-3">
                                                <p class="mb-2 light word-break">Agreed Qty:
                                                    <span class="medium">{{(item?.orderedQuantity) || 'NA'}}
                                                    </span>
                                                </p>
                                                <p class="mb-2 light word-break">Eligible For Inspection:
                                                    <span class="medium">{{(item?.orderedQuantity -
                                                        item?.inspectionPassedQuantity) || 'NA'}}
                                                    </span>
                                                </p>
                                            </div>
                                        </div>

                                    </mat-checkbox>
                                </div>
                            </div>
                            <div *ngIf="batches?.length === 0" class="d-flex flex-column align-items-center">
                                <label class="pb-2 fs-3">No batch ready for inspection yet!</label>
                                <label class="pb-2">Please move stage to Inspection to schedule one.</label>
                            </div>
                        </div>
                    </mat-tab>
                    <mat-tab label="Step 2. Permissions">
                        <div class="pt-4">
                            <div>
                                <label class="col-md-4 px-0">Email ID</label>
                                <label class="col-md-4 px-0">Session Role</label>
                                <label class="col-md-4 px-0">Permissions</label>
                            </div>
                            <div formArrayName="attendees">
                                <div *ngFor="let item of attendeesArray.controls; let i=index" class="d-flex"
                                    [formGroupName]="i">
                                    <div class="col-md-4 px-0">
                                        <mat-form-field appearance="outline" floatLabel="true">
                                            <input formControlName="email" matInput type="text"
                                                placeholder="Ex. pat@example.com">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-4 px-0">
                                        <mat-form-field appearance="outline" floatLabel="true">
                                            <mat-select formControlName="roleId">
                                                <mat-option *ngFor="let role of inspectionRoles"
                                                    [value]="role?.id">{{role?.name}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-4 d-flex justify-content-between px-0">
                                        <span>
                                            <p class="mb-0">{{getRoleDescription(i)}}</p>
                                        </span>
                                        <img *ngIf="i !== 0" (click)="removeAttendeeItem(i)" matTooltip="Delete item"
                                            style="height: 20px; width: 20px;" src="assets/svg/trash.svg" alt="delete">
                                    </div>
                                </div>
                                <div>
                                    <p (click)="addNewAttendeeBatch()" class="link">+ Add more</p>
                                </div>
                            </div>
                        </div>
                    </mat-tab>
                    <mat-tab label="Step 3. Checklists">
                        <div class="pt-4">
                            <label class="px-0 pb-2">Add checklist for each parts</label>
                            <div class="sub-tab">
                                <mat-tab-group [selectedIndex]="0">
                                    <mat-tab *ngFor="let part of batchParts; let j=index" [label]="part?.partName">
                                        <div class="pt-4 d-flex flex-column gap-2">
                                            <div *ngIf="checkLists?.length === 0" class="d-flex">
                                                <div class="col-md-12 px-0 text-center">No checklist items created yet!
                                                </div>
                                            </div>
                                            <div class="d-flex align-items-center"
                                                *ngFor="let item of checkLists[part.partId]; let i=index">
                                                <div class="col-md-11 ps-0">
                                                    <p class="checklist-content py-3 px-1 mb-0">
                                                        {{i+1}}. {{item.title}}
                                                    </p>
                                                </div>
                                                <div class="col-md-1 pe-1 text-end">
                                                    <img (click)="removeCheckListItem(part?.partId, item.id)"
                                                        matTooltip="Delete item" style="margin-right: 8px;"
                                                        src="assets/svg/trash.svg" alt="delete">
                                                </div>
                                            </div>
                                            <!-- :New checklist input -->
                                            <div class="d-flex col-md-12 px-0">
                                                <form class="checklist-form" (submit)="addChecklistItem(part.partId)"
                                                    [formGroup]="checklistForm">
                                                    <mat-form-field class="checklist-full-width" appearance="outline">
                                                        <mat-icon matSuffix (click)="addChecklistItem(part.partId)"
                                                            class="checklist-add">add_box</mat-icon>
                                                        <input formControlName="checkListValue" type="text" matInput
                                                            placeholder="Type checklist entry and press enter/return">
                                                    </mat-form-field>
                                                </form>
                                            </div>
                                        </div>
                                    </mat-tab>
                                </mat-tab-group>
                            </div>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </form>
        </div>
    </div>
    <div class="footer pr-0">
        <div class="col-md-12 d-flex button justify-content-end">
            <button class="white mr-2" (click)="close()">Cancel</button>
            <button (click)="sendInvite()" [disabled]="inspectionForm.invalid || selectedBatches?.length===0 "
                class="orange ml-2">Send Inspection
                Invite</button>
        </div>
    </div>
</div>